// extracted by mini-css-extract-plugin
export default {"banner":"FD_nPmtfbb6_JwFeK4LC","dismissNotification":"A1XVBbIqIorBQadonAhM"};